/* @flow */
import React from 'react';
import classNames from 'classnames';
import { Icon } from 'antd';
import styles from './Result.module.pcss';

type Props = {
  className: string,
  type: string | React$Element<string>,
  title: string | React$Element<string>,
  description: string | React$Element<string>,
  actions: React$Element<string>,
  extra?: string | React$Element<any>,
};

export default function Result({ className, type, title, description, extra, actions, ...restProps }: Props) {
  const iconMap: Object = {
    error: <Icon className={styles.error} type="close-circle" theme="filled" />,
    success: <Icon className={styles.success} type="check-circle" theme="filled" />,
  };
  const clsString = classNames(styles.result, className);
  return (
    <div {...restProps} className={clsString}>
      <div className={styles.icon}>{iconMap[type]}</div>
      <div className={styles.title}>{title}</div>
      {description && <div className={styles.description}>{description}</div>}
      {extra && <div className={styles.extra}>{extra}</div>}
      {actions && <div className={styles.actions}>{actions}</div>}
    </div>
  );
}

Result.defaultProps = {
  extra: null,
};
